import log from "loglevel";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import Select from "../common/Select";
import actions from "./logic/actions";

class TagSelect extends React.Component {
    static defaultProps = {
        placeholder: "Select Review Tags",
        multiple: true,
    };
    constructor(props) {
        super(props);
        let defaultValue;
        if (Array.isArray(props.defaultValue)) {
            defaultValue = props.defaultValue.map((v) => {
                if (typeof v !== "object") {
                    return {
                        value: v,
                        label: props.tags.find((t) => t.id === v).value,
                    };
                }
                return v;
            });
        } else defaultValue = props.defaultValue;

        this.state = {
            value: defaultValue ? defaultValue : props.multiple ? [] : null,
        };
        this.onChange = this.onChange.bind(this);
        this.props.loadTags();
    }
    onChange(value) {
        log.debug("tags", value);
        this.setState({ value }, () => {
            this.props.onChange(this.state.value);
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue });
        }
    }

    render() {
        const { value } = this.state;
        const { tags, multiple, placeholder } = this.props;
        const data = tags.filter((type) => type.value !== "").map((type) => ({ value: type.id, label: type.value }));
        return (
            <Select
                placeholder={placeholder}
                value={value}
                defaultMenuPortalTarget
                multiple={multiple}
                onChange={this.onChange}
                options={data}
            />
        );
    }
}

TagSelect.propTypes = {
    tags: PropTypes.array.isRequired,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    onChange: PropTypes.func.isRequired,
    multiple: PropTypes.bool,
    placeholder: PropTypes.string,
    loadTags: PropTypes.func.isRequired,
};

export default connect(
    ({ globalApp }) => ({
        tags: globalApp.tags,
    }),
    (dispatch) => ({
        loadTags: () => dispatch(actions.ON_LOAD_TAGS.send()),
    })
)(TagSelect);
